<template>
    <div class="tile is-ancestor">
        <div class="tile is-vertical is-parent">
            <div class="tile is-child has-text-left">
                <h1 class="title">Contact</h1>
            </div>

            <!--div class="tile is-child has-text-left">
                <p class="is-italic">Feel free to contact us using this form</p>
            </div -->

            <div class="tile is-child">
                <div class="tile is-ancestor">
                    <!-- div class="tile is-8 is-vertical is-parent">
                        <div class="tile is-child box has-background-white-ter">
                            <section>
                                <form @submit.prevent="validateBeforeSubmit">
                                    <div class="tile is-ancestor has-text-left">
                                        <div class="tile is-parent">
                                            <div class="tile is-child ">
                                                <b-field label="First name"
                                                         :type="{'is-danger': errors.has('firstname')}"
                                                         :message="errors.first('firstname')">
                                                    <b-input v-model="firstname" name="firstname"
                                                             v-validate="'required'"/>
                                                </b-field>

                                                <b-field label="Last name"
                                                         :type="{'is-danger': errors.has('lastname')}"
                                                         :message="errors.first('lastname')">
                                                    <b-input v-model="lastname" name="lastname"
                                                             v-validate="'required'"/>
                                                </b-field>

                                                <b-field label="Email"
                                                         :type="{'is-danger': errors.has('email')}"
                                                         :message="errors.first('email')">
                                                    <b-input type="email" v-model="email" name="email"
                                                             v-validate="'required'"/>
                                                </b-field>

                                                <b-field label="Enquiry"
                                                         :type="{'is-danger': errors.has('enquiry')}"
                                                         :message="errors.first('enquiry')">
                                                    <b-input type="textarea" v-model="enquiry" name="enquiry"
                                                             v-validate="'required'"/>
                                                </b-field>

                                                <div class="has-text-right">
                                                    <button type="submit" class="button is-primary is-large"> Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </section>
                        </div>
                    </div -->
                    <div class="tile is-parent">
                        <div class="tile is-child box has-text-left has-background-white-ter">
                            <div class="tile is-ancestor">
                                <div class="tile is-vertical is-parent">
                                    <div class="tile is-child ">
                                        <p class="title is-4">Our office</p>
                                        <p class="has-text-weight-bold">University of Tartu</p>
                                        <p>Ravila 14a</p>
                                        <p>Tartu 50411</p>
                                        <p>Phone: +372 737 6030</p>
                                    </div>
                                    <div class="tile is-child">
                                        <p class="has-text-weight-bold">Valchrom Developers</p>
                                        <a href="mailto:valchrom@ut.ee?Subject=Enquiry%20Message" target="_top">valchrom@ut.ee</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <!-- <div class="tile is-child box">
                <p class="title">Two</p>
            </div> -->
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ContactComponent',
        data: function () {
            return {
                firstname: null,
                lastname: null,
                email: null,
                enquiry: null,
            }
        },
        methods: {
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$toast.open({
                            message: 'Enquiry Submitted!',
                            type: 'is-success',
                            position: 'is-top'
                        })
                        return;
                    }
                    this.$toast.open({
                        message: 'Form is not valid! Please check the fields.',
                        type: 'is-danger',
                        position: 'is-top'
                    })
                });
            },
        }

    }
</script>

